import { ReactElement } from 'react';
import { StringKeyOf } from 'ia-react-core/~/interfaces/StringKeyOf';
import throwError from '../error/_throwError';

type TypedReactNode<Props> = null | string | number | boolean | undefined | ReactElement<Props> | Iterable<TypedReactNode<Props>>;

export default function filterPropsByComponent<
  TypeProps extends object,
  Props extends Partial<TypeProps>,
>(props: Props, Component: ((props: TypeProps) => TypedReactNode<TypeProps>) & { publicProps: readonly StringKeyOf<Partial<TypeProps>>[] }) {
  if (!Component.publicProps) {
    throwError('filterPropsByComponent: Component passed must have a "publicProps" static prop.');
  }

  return Component.publicProps.reduce((result, propName) => {
    if (typeof props[propName] !== 'undefined') {
      result[propName] = props[propName];
    }

    return result;
  }, {} as Props);
}
